import React from 'react'
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { AuthProvider } from './contexts/AuthContext'
import { useAuth } from './contexts/AuthContext'
import { ProtectedRoute, AdminRoute } from './components/ProtectedRoute'

import Login from './pages/Login'
import Dashboard from './pages/Dashboard'
import DashboardFinance from './pages/DashboardFinance'
import DashboardOps from './pages/DashboardOps'
import DashboardStaff from './pages/DashboardStaff'
import FarmLog from './pages/FarmLog'
import CashLog from './pages/CashLog'
import Inventory from './pages/Inventory'
import AdminUsers from './pages/AdminUsers'
import HarvestLog from './pages/HarvestLog'
import Invoices from './pages/Invoices'
import WeeklyPL from './pages/WeeklyPL'
import Timesheets from './pages/Timesheets'
import StaffRegister from './pages/StaffRegister'
import CropCycles from './pages/CropCycles'
import SalesOrders from './pages/SalesOrders'
import VisitorLog from './pages/VisitorLog'
import QualityControl from './pages/QualityControl'
import Logistics from './pages/Logistics'
import Procurement from './pages/Procurement'
import IncidentReports from './pages/IncidentReports'
import SOPs from './pages/SOPs'
import Emergency from './pages/Emergency'
import AdminReports from './pages/AdminReports'
import Customers from './pages/Customers'
import Requisitions from './pages/Requisitions'
import GoodsReceived from './pages/GoodsReceived'
import Payables from './pages/Payables'
import Tasks from './pages/Tasks'
import AdminSettings from './pages/AdminSettings'
import FixedAssets from './pages/FixedAssets'
import Loans from './pages/Loans'
import FinancialStatements from './pages/FinancialStatements'
import JournalLedger from './pages/JournalLedger'
import Equity from './pages/Equity'
import PeriodClose from './pages/PeriodClose'
import MLInsights from './pages/MLInsights'
import { AdminInvites } from './pages/Placeholders'

import './index.css'

function RoleDashboard() {
  const { userRole, loading } = useAuth()
  if (loading) return null
  if (userRole === 'finance_admin') return <Navigate to="/dashboard/finance" replace />
  if (userRole === 'ops_admin') return <Navigate to="/dashboard/ops" replace />
  return <Navigate to="/dashboard/staff" replace />
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/dashboard" element={<ProtectedRoute><RoleDashboard /></ProtectedRoute>} />
          <Route path="/dashboard/finance" element={<ProtectedRoute><DashboardFinance /></ProtectedRoute>} />
          <Route path="/dashboard/ops" element={<ProtectedRoute><DashboardOps /></ProtectedRoute>} />
          <Route path="/dashboard/staff" element={<ProtectedRoute><DashboardStaff /></ProtectedRoute>} />
          <Route path="/tasks" element={<ProtectedRoute><Tasks /></ProtectedRoute>} />
          <Route path="/farm-log" element={<ProtectedRoute><FarmLog /></ProtectedRoute>} />
          <Route path="/harvest" element={<ProtectedRoute><HarvestLog /></ProtectedRoute>} />
          <Route path="/quality" element={<ProtectedRoute><QualityControl /></ProtectedRoute>} />
          <Route path="/logistics" element={<ProtectedRoute><Logistics /></ProtectedRoute>} />
          <Route path="/cash-log" element={<ProtectedRoute><CashLog /></ProtectedRoute>} />
          <Route path="/invoices" element={<ProtectedRoute><Invoices /></ProtectedRoute>} />
          <Route path="/customers" element={<ProtectedRoute><Customers /></ProtectedRoute>} />
          <Route path="/weekly-pl" element={<ProtectedRoute><WeeklyPL /></ProtectedRoute>} />
          <Route path="/procurement" element={<ProtectedRoute><Procurement /></ProtectedRoute>} />
          <Route path="/requisitions" element={<ProtectedRoute><Requisitions /></ProtectedRoute>} />
          <Route path="/goods-received" element={<ProtectedRoute><GoodsReceived /></ProtectedRoute>} />
          <Route path="/payables" element={<ProtectedRoute><Payables /></ProtectedRoute>} />
          <Route path="/inventory" element={<ProtectedRoute><Inventory /></ProtectedRoute>} />
          <Route path="/timesheets" element={<ProtectedRoute><Timesheets /></ProtectedRoute>} />
          <Route path="/staff-register" element={<ProtectedRoute><StaffRegister /></ProtectedRoute>} />
          <Route path="/crop-cycles" element={<AdminRoute><CropCycles /></AdminRoute>} />
          <Route path="/sales-orders" element={<ProtectedRoute><SalesOrders /></ProtectedRoute>} />
          <Route path="/visitors" element={<ProtectedRoute><VisitorLog /></ProtectedRoute>} />
          <Route path="/incidents" element={<ProtectedRoute><IncidentReports /></ProtectedRoute>} />
          <Route path="/sops" element={<ProtectedRoute><SOPs /></ProtectedRoute>} />
          <Route path="/emergency" element={<ProtectedRoute><Emergency /></ProtectedRoute>} />
          <Route path="/fixed-assets" element={<AdminRoute><FixedAssets /></AdminRoute>} />
          <Route path="/loans" element={<AdminRoute><Loans /></AdminRoute>} />
          <Route path="/financial-statements" element={<AdminRoute><FinancialStatements /></AdminRoute>} />
          <Route path="/journal-ledger" element={<AdminRoute><JournalLedger /></AdminRoute>} />
          <Route path="/equity" element={<AdminRoute><Equity /></AdminRoute>} />
          <Route path="/period-close" element={<AdminRoute><PeriodClose /></AdminRoute>} />
          <Route path="/admin/users" element={<AdminRoute><AdminUsers /></AdminRoute>} />
          <Route path="/admin/invites" element={<AdminRoute><AdminInvites /></AdminRoute>} />
          <Route path="/admin/reports" element={<AdminRoute><AdminReports /></AdminRoute>} />
          <Route path="/admin/settings" element={<AdminRoute><AdminSettings /></AdminRoute>} />
          <Route path="/ml-insights" element={<ProtectedRoute><MLInsights /></ProtectedRoute>} />
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  )
}
